import React from 'react'

function Subestacion1(props) {

    const { svgData, data } = props;

    //seccionadores
    var secc89PTL, secc89L, secc89H01, secc57H01A, secc57H01B, secc57H02, secc89H02, secc89H03, secc57H03, secc89H04, secc57H04
    var secc89PTLcolor, secc89Lcolor, secc89H01color, secc57H01Acolor, secc57H01Bcolor, secc57H02color, secc89H02color, secc89H03color, secc57H03color, secc89H04color, secc57H04color
    //reles
    var H0250BF, PT_T1_UCP_IDF50BF, PT_T1_UCP_IDF86
    //interruptores
    var inte52HTA, inteH02, inteH03, inteH04
    var inte52HTAcolor, inteH02color, inteH03color, inteH04color
    var estado52HTA, estadointeH02 = "?", estadointeH03 = "?", estadointeH04 = "?"

    if (svgData.length > 0) {
        for (let i = 0; i < svgData.length; i++) {

            if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89PTL-A") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#33BBC2"
                        break;
                    case "indeterminado":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#000000"
                        break;
                    case "desconocido":
                        secc89PTL = "m97.993 39.952 1.159.985"
                        secc89PTLcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc89PTL = "m97.462 41.217 1.521 -.005"
                        secc89PTLcolor = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89L-HTA") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#33BBC2"
                        break;
                    case "indeterminado":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#000000"
                        break;
                    case "desconocido":
                        secc89L = "m97.113 44.169-.841 1.225"
                        secc89Lcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc89L = "m96.057 43.784-.004 1.486"
                        secc89Lcolor = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57T1" && svgData[i].posicion === "H01") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H01A = "m84.402 75.737 1.264.846"
                        secc57H01B = "m84.28 81.133 1.24.883"
                        secc57H01Acolor = "#c1c134"
                        secc57H01Bcolor = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H01A = "m84.402 75.737 1.264.846"
                        secc57H01B = "m84.28 81.133 1.24.883"
                        secc57H01Acolor = "#000000"
                        secc57H01Bcolor = "#000000"
                        break;
                    case "desconocido":
                        secc57H01A = "m84.402 75.737 1.264.846"
                        secc57H01B = "m84.28 81.133 1.24.883"
                        secc57H01Acolor = "#ff0000"
                        secc57H01Bcolor = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H01A = "m84.007 76.803 1.522-.006"
                        secc57H01B = "m83.918 82.254 1.52-.002"
                        secc57H01Acolor = "#c1c134"
                        secc57H01Bcolor = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89T1" && svgData[i].posicion === "H01") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H01 = "m83.633 74.398-.749 1.016"
                        secc89H01color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H01 = "m83.633 74.398-.749 1.016"
                        secc89H01color = "#000000"
                        break;
                    case "desconocido":
                        secc89H01 = "m83.633 74.398-.749 1.016"
                        secc89H01color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H01 = "m82.635 74.067-.005 1.263"
                        secc89H01color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57" && svgData[i].posicion === "CELDA H02 TRAFO 1") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H02 = "m97.835 59.175 1.239.883"
                        secc57H02color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H02 = "m97.835 59.175 1.239.883"
                        secc57H02color = "#000000"
                        break;
                    case "desconocido":
                        secc57H02 = "m97.835 59.175 1.239.883"
                        secc57H02color = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H02 = "m97.447 60.306h1.521"
                        secc57H02color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89" && svgData[i].posicion === "CELDA H02 TRAFO 1") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H02 = "m97.146 63.233-.877 1.434"
                        secc89H02color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H02 = "m97.146 63.233-.877 1.434"
                        secc89H02color = "#000000"
                        break;
                    case "desconocido":
                        secc89H02 = "m97.146 63.233-.877 1.434"
                        secc89H02color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H02 = "m96.072 62.9-.01 1.682"
                        secc89H02color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57" && svgData[i].posicion === "CELDA H03 LINEA 1") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H03 = "m94.054 80.857 1.192.945"
                        secc57H03color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H03 = "m94.054 80.857 1.192.945"
                        secc57H03color = "#000000"
                        break;
                    case "desconocido":
                        secc57H03 = "m94.054 80.857 1.192.945"
                        secc57H03color = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H03 = "m93.661 82.01 1.521.007"
                        secc57H03color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89" && svgData[i].posicion === "CELDA H03 LINEA 1") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H03 = "m93.109 78.372-.63 1.095"
                        secc89H03color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H03 = "m93.109 78.372-.63 1.095"
                        secc89H03color = "#000000"
                        break;
                    case "desconocido":
                        secc89H03 = "m93.109 78.372-.63 1.095"
                        secc89H03color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H03 = "m92.282 78.098.003 1.263"
                        secc89H03color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "57" && svgData[i].posicion === "CELDA H04 LINEA 2") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc57H04 = "m104.854 80.857 1.192.945"
                        secc57H04color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc57H04 = "m104.854 80.857 1.192.945"
                        secc57H04color = "#000000"
                        break;
                    case "desconocido":
                        secc57H04 = "m104.854 80.857 1.192.945"
                        secc57H04color = "#ff0000"
                        break;
                    case "cerrado":
                        secc57H04 = "m104.361 82.01 1.521.007"
                        secc57H04color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "seccionador" && svgData[i].nombre === "89" && svgData[i].posicion === "CELDA H04 LINEA 2") {
                switch (svgData[i].estado) {
                    case "abierto":
                        secc89H04 = "m103.952 78.393-.696 1.054"
                        secc89H04color = "#c1c134"
                        break;
                    case "indeterminado":
                        secc89H04 = "m103.952 78.393-.696 1.054"
                        secc89H04color = "#000000"
                        break;
                    case "desconocido":
                        secc89H04 = "m103.952 78.393-.696 1.054"
                        secc89H04color = "#ff0000"
                        break;
                    case "cerrado":
                        secc89H04 = "m103.01 78.072.002 1.262"
                        secc89H04color = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "CELDA H02 TRAFO 1"){
                switch(svgData[i].estado){
                    case "normal":
                        H0250BF = "none"
                        break;
                    case "disparado":
                        H0250BF = "#c1c134"
                        break;
                }
            } else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "PT_T1_UCP_IDF" && svgData[i].nombre === "50BF"){
                switch(svgData[i].estado){
                    case "normal":
                        PT_T1_UCP_IDF50BF = "none"
                        break;
                    case "disparado":
                        PT_T1_UCP_IDF50BF = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "rele" && svgData[i].posicion === "PT_T1_UCP_IDF" && svgData[i].nombre === "86"){
                switch(svgData[i].estado){
                    case "normal":
                        PT_T1_UCP_IDF86 = "none"
                        break;
                    case "disparado":
                        PT_T1_UCP_IDF86 = "#33BBC2"
                        break;
                }
            } else if (svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "PT_T1_UCP_IDF") {
                switch (svgData[i].estado) {
                    case "abierto":
                        inte52HTA = "url(#cuadradoAzul)"
                        inte52HTAcolor = "#fff"
                        break;
                    case "indeterminado":
                        inte52HTA = "url(#cruzAzul)"
                        inte52HTAcolor = "#33BBC2"
                        break;
                    case "desconocido":
                        inte52HTA = "url(#cruzAzul)"
                        inte52HTAcolor = "#33BBC2"
                        break;
                    case "cerrado":
                        inte52HTA = "url(#cuadradoAzul)"
                        inte52HTAcolor = "#33BBC2"
                        break;
                }
                if(svgData[i].conexion === "remoto"){
                    estado52HTA = "none"
                    estadointeH02 = "R"
                    estadointeH03 = "R"                    
                    estadointeH04 = "R"
                } else if (svgData[i].conexion === "local") {
                    estado52HTA = "#33BBC2"
                    estadointeH02 = "L"
                    estadointeH03 = "L"                    
                    estadointeH04 = "L"
                }
            } else if(svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "CELDA H02 TRAFO 1"){
                switch(svgData[i].estado){
                    case "abierto":
                        inteH02 = "url(#cuadradoAmarilloH02)"
                        inteH02color = "#fff"
                        break;
                    case "indeterminado":
                        inteH02 = "url(#cruzAmarillaH02)"
                        inteH02color = "#c1c134"
                        break;
                    case "desconocido":
                        inteH02 = "url(#cruzAmarillaH02)"
                        inteH02color = "#c1c134"
                        break;
                    case "cerrado":
                        inteH02 = "url(#cuadradoAmarilloH02)"
                        inteH02color = "#c1c134"
                        break;
                }
            } else if(svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "CELDA H03 LINEA 1"){
                switch(svgData[i].estado){
                    case "abierto":
                        inteH03 = "url(#cuadradoAmarilloH03)"
                        inteH03color = "#fff"
                        break;
                    case "indeterminado":
                        inteH03 = "url(#cruzAmarillaH03)"
                        inteH03color = "#c1c134"
                        break;
                    case "desconocido":
                        inteH03 = "url(#cruzAmarillaH03)"
                        inteH03color = "#c1c134"
                        break;
                    case "cerrado":
                        inteH03 = "url(#cuadradoAmarilloH03)"
                        inteH03color = "#c1c134"
                        break;
                }
            } else if(svgData[i].dispositivo === "interruptor" && svgData[i].posicion === "CELDA H04 LINEA 2"){
                switch(svgData[i].estado){
                    case "abierto":
                        inteH04 = "url(#cuadradoAmarilloH04)"
                        inteH04color = "#fff"
                        break;
                    case "indeterminado":
                        inteH04 = "url(#cruzAmarillaH04)"
                        inteH04color = "#c1c134"
                        break;
                    case "desconocido":
                        inteH04 = "url(#cruzAmarillaH04)"
                        inteH04color = "#c1c134"
                        break;
                    case "cerrado":
                        inteH04 = "url(#cuadradoAmarilloH04)"
                        inteH04color = "#c1c134"
                        break;
                }
            }
        }
    }

    var A01 = -1, A02 = -1, A03 = -1, A04 = -1, A05 = -1, A06 = -1, A07 = -1, A08 = -1, A09 = -1, A10 = -1, toma = -1

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            switch (data[i].posicion) {
                case "IDF TRAFO 1":
                    A01 = data[i].Vab
                    A02 = data[i].Ia
                    A03 = data[i].P
                    A04 = data[i].Q
                    if(data[i].toma !== null) { toma = data[i].toma }
                    break;
                case "CELDA H02 TRAFO 1":
                    A05 = data[i].Ia
                    A06 = data[i].P
                    A07 = data[i].Q
                    A08 = data[i].Vab
                    break;
                case "CELDA H03 LINEA 1":
                    A09 = data[i].Ia
                    break;
                case "CELDA H04 LINEA 2":
                    A10 = data[i].Ia
                    break;
            }
        }
    }

    return (
        <svg
            width="170mm"
            height="237mm"
            viewBox="88 33 15 57"
            version="1.1"
            id="svg5"
            xmlns="http://www.w3.org/2000/svg">
            <defs>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="circuloAzul"
                    refX={2}
                    refY={0}
                    orient="auto"
                    markerWidth={2.4}
                    markerHeight={2.4}
                    viewBox="0 0 5.4 5.4"
                    preserveAspectRatio="xMidYMid"
                    stroke="#33BBC2"
                    fill="none"
                >
                    <path
                        transform="scale(.45)"
                        style={{
                            fill: "context-fill",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: 2,
                        }}
                        d="M5 0c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.3-5 5-5c2.76 0 5 2.24 5 5z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="circuloAmarillo"
                    refX={2}
                    refY={0}
                    orient="auto"
                    markerWidth={2.4}
                    markerHeight={2.4}
                    viewBox="0 0 5.4 5.4"
                    preserveAspectRatio="xMidYMid"
                    stroke="#C1C134"
                    fill="none"
                >
                    <path
                        transform="scale(.45)"
                        style={{
                            fill: "context-fill",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: 2,
                        }}
                        d="M5 0c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.3-5 5-5c2.76 0 5 2.24 5 5z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="flechaAzul"
                    refX={0}
                    refY={0}
                    orient="auto-start-reverse"
                    markerWidth={2.135}
                    markerHeight={2.064}
                    viewBox="0 0 6.135 5.93"
                    preserveAspectRatio="xMidYMid"
                    stroke="#33BBC2"
                    fill="#33BBC2"
                >
                    <path
                        transform="scale(.7)"
                        d="M-.211-4.106 6.21-.894a1 1 90 0 1 0 1.788L-.21 4.106A1.236 1.236 31.717 0 1-2 3v-6A1.236 1.236 148.283 0 1-.211-4.106z"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "none",
                        }}
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="flechaAmarilla"
                    refX={0}
                    refY={0}
                    orient="auto-start-reverse"
                    markerWidth={2.135}
                    markerHeight={2.064}
                    viewBox="0 0 6.135 5.93"
                    preserveAspectRatio="xMidYMid"
                    stroke="#C1C134"
                    fill="#C1C134"
                >
                    <path
                        transform="scale(.7)"
                        d="M-.211-4.106 6.21-.894a1 1 90 0 1 0 1.788L-.21 4.106A1.236 1.236 31.717 0 1-2 3v-6A1.236 1.236 148.283 0 1-.211-4.106z"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "none",
                        }}
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="flechaBlanca"
                    refX={0}
                    refY={0}
                    orient="auto-start-reverse"
                    markerWidth={2.135}
                    markerHeight={2.064}
                    viewBox="0 0 6.135 5.93"
                    preserveAspectRatio="xMidYMid"
                    stroke="#808080"
                    fill="#808080"
                >
                    <path
                        transform="scale(.7)"
                        d="M-.211-4.106 6.21-.894a1 1 90 0 1 0 1.788L-.21 4.106A1.236 1.236 31.717 0 1-2 3v-6A1.236 1.236 148.283 0 1-.211-4.106z"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "none",
                        }}
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarilloH02"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH02color}
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarilloH03"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH03color}
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAmarilloH04"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH04color}
                    stroke="#C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="barraAzul"
                    refX={0}
                    refY={0}
                    orient="auto"
                    markerWidth={0.41}
                    markerHeight={3}
                    viewBox="0 0 1 8"
                    preserveAspectRatio="none"
                    fill="#33BBC2"
                    stroke="#33BBC2"
                >
                    <path
                        style={{
                            fill: "none",
                            stroke: "context-stroke",
                            strokeWidth: 1,
                        }}
                        d="M0 4v-8"
                    />
                </marker>
                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="barraAmarilla"
                    refX={0}
                    refY={0}
                    orient="auto"
                    markerWidth={0.41}
                    markerHeight={3}
                    viewBox="0 0 1 8"
                    preserveAspectRatio="none"
                    fill="#C1C134"
                    stroke="#C1C134"
                >
                    <path
                        style={{
                            fill: "none",
                            stroke: "context-stroke",
                            strokeWidth: 1,
                        }}
                        d="M0 4v-8"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cuadradoAzul"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inte52HTAcolor}
                    stroke="#33BBC2"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>


                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAzul"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inte52HTAcolor}
                    stroke="#33BBC2"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAmarillaH02"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH02color}
                    stroke="C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAmarillaH03"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH03color}
                    stroke="C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="cruzAmarillaH04"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={3.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="xMidYMid"
                    fill={inteH04color}
                    stroke="C1C134"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "context-stroke",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="m-3.5 4.5 9-9m0 9-9-9"
                    />
                </marker>

                <marker
                    style={{
                        overflow: "visible",
                    }}
                    id="rectanguloAmarillo"
                    refX={-2}
                    refY={0}
                    orient="auto"
                    markerWidth={6.667}
                    markerHeight={3.667}
                    viewBox="0 0 5.667 5.667"
                    preserveAspectRatio="none"
                    stroke="#C1C134"
                    fill="#none"
                >
                    <path
                        transform="scale(.5)"
                        style={{
                            fill: "none",
                            fillRule: "evenodd",
                            stroke: "context-stroke",
                            strokeWidth: "1pt",
                        }}
                        d="M-5-5V5H5V-5Z"
                    />
                </marker>

            </defs>
            <g
                style={{
                    display: "inline",
                }}
            >
                <path
                    style={{
                        fill: "#34bac1",
                        fillOpacity: 1,
                        stroke: "#34bac1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#flechaAzul)",
                        markerEnd: "url(#barraAzul)",
                        paintOrder: "normal",
                        fillRule: "nonzero",
                    }}
                    d="M96.044 38.2v5.514"
                />
                <path
                    id='llave2'
                    style={{
                        fill: "none",
                        stroke: secc89Lcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89L}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAzul)",
                        markerEnd: inte52HTA,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M96.055 45.99v2.7"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M96.055 49.81v2.14"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M97.143 52.97a1.081 1.087 0 0 1-1.074 1.095 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.094 1.081 1.087 0 0 1 1.088 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M97.144 54.193a1.081 1.087 0 0 1-1.075 1.094 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.094 1.081 1.087 0 0 1 1.089 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M96.069 55.319v7.513"
                />
                <path
                    id='llave4'
                    style={{
                        fill: "none",
                        stroke: secc89H02color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H02}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: inteH02,
                        paintOrder: "normal",
                    }}
                    d="M96.062 65.307v3.864"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M96.062 70.104v2.14"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M78.214 72.263h31.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M82.625 72.377v1.649"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: inteH03,
                        paintOrder: "normal",
                    }}
                    d="M92.29 72.387v1.986"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M92.278 75.556v2.502"
                />
                <path
                    id='llave8'
                    style={{
                        fill: "none",
                        stroke: secc89H03color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H03}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M92.313 80.07v5.127"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M92.36 82.022h1.24"
                />
                <path
                    id='llave9'
                    style={{
                        fill: "none",
                        stroke: secc57H03color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H03}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M95.888 82.027h1.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: inteH04,
                        paintOrder: "normal",
                    }}
                    d="M103.017 72.38v1.985"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M103.006 75.548v2.502"
                />
                <path
                    id='llave10'
                    style={{
                        fill: "none",
                        stroke: secc89H04color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H04}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M103.04 80.061v5.114"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M103.087 82.014h1.241"
                />
                <path
                    id='llave11'
                    style={{
                        fill: "none",
                        stroke: secc57H04color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H04}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M106.574 82.019h1.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M96.15 60.318h1.24"
                />
                <path
                    id='llave3'
                    style={{
                        fill: "none",
                        stroke: secc57H02color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H02}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M99.694 60.306h1.584"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAzul)",
                        paintOrder: "normal",
                    }}
                    d="M96.19 41.211h1.241"
                />
                <path
                    id='llave1'
                    style={{
                        fill: "none",
                        stroke: secc89PTLcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89PTL}
                />
                <path
                    style={{
                        fill: "#33bbc2",
                        stroke: "#34b9c1",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAzul)",
                        markerEnd: "url(#flechaAzul)",
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M99.702 41.216h1.584"
                />
                <path
                    id='llave5'
                    style={{
                        fill: "none",
                        stroke: secc89H01color,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc89H01}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#rectanguloAmarillo)",
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.624 76.047v2.502"
                />
                <path
                    style={{
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.622 77.641v4.405"
                />
                <path
                    style={{
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.622 80.641v4.405"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M83.73 86.113a1.081 1.087 0 0 1-1.075 1.094 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.093 1.081 1.087 0 0 1 1.088 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#808080",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M83.697 87.603a1.081 1.087 0 0 1-1.074 1.094 1.081 1.087 0 0 1-1.088-1.08 1.081 1.087 0 0 1 1.074-1.094 1.081 1.087 0 0 1 1.088 1.08"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M82.67 82.25h1.24"
                />
                <path
                    id='llave7'
                    style={{
                        fill: "none",
                        stroke: secc57H01Acolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H01A}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M86.123 82.24H88"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#barraAmarilla)",
                        paintOrder: "normal",
                    }}
                    d="M82.754 76.82h1.24"
                />
                <path
                    id='llave6'
                    style={{
                        fill: "none",
                        stroke: secc57H01Bcolor,
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d={secc57H01B}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerStart: "url(#circuloAmarillo)",
                        paintOrder: "normal",
                    }}
                    d="M86.21 76.812h1.225"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#c1c134",
                        strokeWidth: 0.473999,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M87.248 82.079v-5.437"
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#808080",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        markerEnd: "url(#flechaBlanca)",
                        paintOrder: "normal",
                    }}
                    d="M82.583 88.695v.58"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={86.205}
                    y={40}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={39.5}
                    >
                        {A01}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={41}
                    >
                        {A02}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={42.5}
                    >
                        {A03}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={86.205}
                        y={44}
                    >
                        {A04}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={89.412}
                    y={40}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={39.5}
                    >
                        {"kV"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={41}
                    >
                        {"A"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={42.5}
                    >
                        {"MW"}
                    </tspan>
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={89.412}
                        y={44}
                    >
                        {"MVAr"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bac1",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={86.277}
                    y={53.391}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bac1",
                            fillOpacity: 1,
                        }}
                        x={86.277}
                        y={53.391}
                    >
                        {"TOMA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90.165}
                    y={53.381}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={90.165}
                        y={53.391}
                    >
                        {toma}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={82.265}
                    y={51.254}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={82.421}
                        y={51.254}
                    >
                        {"REG EN LOCAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={82}
                    y={52.313}
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={82}
                        y={52.313}
                    >
                        {"AUTO/MANUAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={83.5}
                    y={49.85}
                >
                    <tspan
                        style={{
                            fill: "#33bbc2",
                            stroke: "#33bbc2",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fillOpacity: 1,
                        }}
                        x={83.5}
                        y={49.85}
                    >
                        {"REGULADOR"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        fillOpacity: 1,
                        stroke: "#c1c134",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={87}
                    y={65}
                >
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={65}
                    >
                        {A05}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={66.5}
                    >
                        {A06}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={87}
                        y={68}
                    >
                        {A07}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        fillOpacity: 1,
                        stroke: "#c1c134",
                        strokeWidth: 0.08,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={91.506}
                    y={65}
                >
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={65}
                    >
                        {"A"}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={66.5}
                    >
                        {"MW"}
                    </tspan>
                    <tspan
                        style={{
                            fill: "#c2c233",
                            fillOpacity: 1,
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                        }}
                        x={91.506}
                        y={68}
                    >
                        {"MVAR"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#32bac2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={114.287}
                    y={35.018}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#32bac2",
                            fillOpacity: 1,
                        }}
                        x={114.287}
                        y={35.018}
                    >
                        {"89PTL-A"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.159}
                    y={39.021}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={112.159}
                        y={39.021}
                    >
                        {"89L-HTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.064}
                    y={43.508}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={112.064}
                        y={43.508}
                    >
                        {"52HTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.684}
                    y={45.118}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={116.7}
                        y={45.25}
                    >
                        {"POSICION EN LOCAL"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={114.098}
                    y={51.517}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={114.098}
                        y={51.517}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={112.292}
                    y={55.63}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={112.292}
                        y={55.63}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={111.503}
                    y={60.793}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={111.503}
                        y={60.793}
                    >
                        {"52"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108.537}
                    y={60.778}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={108.537}
                        y={60.778}
                    >
                        {estadointeH02}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={96.158}
                    y={64.503}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={96.158}
                        y={64.503}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={98.155}
                    y={65.869}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={98.155}
                        y={65.869}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={98.25}
                    y={70.586}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={98.25}
                        y={70.586}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={107.225}
                    y={67.746}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={107.225}
                        y={67.746}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={107.396}
                    y={65.337}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={107.396}
                        y={65.337}
                    >
                        {"52"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119.661}
                    y={65.308}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={119.661}
                        y={65.308}
                    >
                        {"52"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119.775}
                    y={67.818}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={119.775}
                        y={67.818}
                    >
                        {"89"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.486}
                    y={65.351}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={116.486}
                        y={65.351}
                    >
                        {estadointeH04}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={104.316}
                    y={65.308}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={104.316}
                        y={65.308}
                    >
                        {estadointeH03}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={109.412}
                    y={70.384}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={109.412}
                        y={70.384}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={121.563}
                    y={70.471}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={121.563}
                        y={70.471}
                    >
                        {"57"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90.101}
                    y={62.504}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={90.101}
                        y={62.504}
                    >
                        {"BARRA 1"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={125.086}
                    y={62.544}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={124.8}
                        y={62.544}
                    >
                        {"kV"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={124.398}
                    y={72.889}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={124.5}
                        y={72.889}
                    >
                        {A10}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={125.745}
                    y={72.892}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={128.745}
                        y={72.892}
                    >
                        {"A"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={95.5}
                    y={73.232}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={95.5}
                        y={73.232}
                    >
                        {"DE CELDA H05"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: H0250BF,
                        stroke: "#c1c134",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={98.863}
                    y={69.323}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={115.2}
                    y={60.9}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={115.2}
                        y={60.9}
                    >
                        {"50BF"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.282}
                    y={45.724}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={40.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={40.4}
                    >
                        {"49"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: PT_T1_UCP_IDF86,
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.281}
                    y={46.8}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={41.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={41.4}
                    >
                        {"86"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: PT_T1_UCP_IDF50BF,
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.7}
                    height={0.7}
                    x={101.276}
                    y={48}
                    ry={0}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={118}
                    y={42.4}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={118}
                        y={42.4}
                    >
                        {"50BF"}
                    </tspan>
                </text>
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={9.808}
                    height={1.5}
                    x={81.5}
                    y={48.756}
                    ry={0}
                />
                <rect
                    style={{
                        fill: "none",
                        stroke: "#33bbc2",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={9.808}
                    height={4.022}
                    x={81.5}
                    y={50.259}
                    ry={0}
                />
                <rect
                    style={{
                        fill: "#33bbc2",
                        fillOpacity: 1,
                        stroke: "#33bbc2",
                        strokeWidth: 0.02,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    width={0.567}
                    height={0.576}
                    x={90.069}
                    y={51.734}
                    ry={0}
                />
                <path
                    style={{
                        fill: "none",
                        stroke: "#34bac1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M90.628 51.017a.3.302 0 0 1-.298.304.3.302 0 0 1-.303-.3.3.302 0 0 1 .299-.305.3.302 0 0 1 .302.3"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={105.231}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={105.231}
                        y={31.5}
                    >
                        {"TRAFO 1 PLANTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        fillOpacity: 1,
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    x={106.263}
                    y={32.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            fill: "#33bbc2",
                            fillOpacity: 1,
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                        }}
                        x={106.263}
                        y={32.5}
                    >
                        {"   A SET PLANTA"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={113.2}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={113.2}
                        y={31.5}
                    >
                        {"45"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33bbc2",
                        stroke: "#33bbc2",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={115.5}
                    y={31.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33bbc2",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#33bbc2",
                            fillOpacity: 1,
                        }}
                        x={115.5}
                        y={31.5}
                    >
                        {"kV"}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={121}
                    y={62.523}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={121}
                        y={62.523}
                    >
                        {A08}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "3.175px",
                        fill: "#33bbc2",
                        fillOpacity: 1,
                        stroke: "#7633c2",
                        strokeWidth: 0.473999,
                    }}
                    x={87.461}
                    y={86.32}
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={111}
                    y={72.908}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.08,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={111}
                        y={72.908}
                    >
                        {A09}
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.07,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={113.303}
                    y={72.911}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#c1c134",
                            strokeWidth: 0.07,
                            strokeOpacity: 1,
                            fill: "#c2c233",
                            fillOpacity: 1,
                        }}
                        x={115.303}
                        y={72.911}
                    >
                        {"A"}
                    </tspan>
                </text>

                <path
                    style={{
                        fill: "#10f",
                        fillOpacity: 1,
                        stroke: "#10f",
                        strokeWidth: 0.02,
                        strokeOpacity: 1,
                    }}
                    d="M14.582 52.822h10.635v4.142H14.582z"
                />

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={89}
                    y={76.5}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90}
                    y={77.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={90}
                        y={77.5}
                    >
                        {"H01"}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={119}
                    y={51.9}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={120}
                    y={50}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={120}
                        y={53}
                    >
                        {"H02"}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={104}
                    y={76.5}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={105}
                    y={77.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={105}
                        y={77.5}
                    >
                        {"H03"}
                    </tspan>
                </text>

                <rect
                    width={4}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={116.3}
                    y={76.5}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={117.4}
                    y={77.5}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={117.4}
                        y={77.5}
                    >
                        {"H04"}
                    </tspan>
                </text>


                <path
                    style={{
                        fill: estado52HTA,
                        stroke: "#34bac1",
                        strokeWidth: 0.1,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 3.8,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                    }}
                    d="M101.29 51.641a.3.302 0 0 1-.299.305.3.302 0 0 1-.303-.3.3.302 0 0 1 .3-.305.3.302 0 0 1 .302.3"
                />
                <path
                    style={{
                        fill: "#c2c233",
                        stroke: "#c1c134",
                        strokeWidth: 0.4,
                        strokeLinecap: "butt",
                        strokeLinejoin: "miter",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeOpacity: 1,
                        markerEnd: "url(#flechaAmarilla)",
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    d="M82.44 84.584h6.625"
                />

                <rect
                    width={5}
                    height={1.5}
                    style={{
                        fontSize: "1px",
                        fill: "#0046FF",
                        stroke: "#white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108}
                    y={29}
                    transform="scale(.86963 1.14992)"
                />
                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "white",
                        stroke: "white",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={108.5}
                    y={30}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "white",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "white",
                            fillOpacity: 1,
                        }}
                        x={108.5}
                        y={30}
                    >
                        {"LIN-TRF1"}
                    </tspan>
                </text>

                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "black",
                        stroke: "black",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={90}
                    y={30}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "black",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "black",
                            fillOpacity: 1,
                        }}
                        x={90}
                        y={30}
                    >
                        {"Subestacion general"}
                    </tspan>
                </text>

                <text
                    xmlSpace="preserve"
                    style={{
                        fontSize: "1px",
                        fill: "#33BBC2",
                        stroke: "#33BBC2",
                        strokeWidth: 0.06,
                        strokeLinecap: "butt",
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 4,
                        strokeDasharray: "none",
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                        paintOrder: "normal",
                        fillOpacity: 1,
                    }}
                    x={100}
                    y={30}
                    transform="scale(.86963 1.14992)"
                >
                    <tspan
                        style={{
                            stroke: "#33BBC2",
                            strokeWidth: 0.06,
                            strokeOpacity: 1,
                            fill: "#33BBC2",
                            fillOpacity: 1,
                        }}
                        x={100}
                        y={30}
                    >
                        {"C"}
                    </tspan>
                </text>

            </g>
        </svg>
    )
}

export default Subestacion1